<template>
    <div class="zv-copyright">
        <span>Copyright &copy; 2020 湖南刺猬安全技术咨询有限公司 All rights reserved.</span>
    </div>
</template>

<script>
    export default {
        name: "ZvCopyright"
    }
</script>

<style scoped>
    .zv-copyright{
        font-size:12px;
        color:#ccc;
    }
</style>
